export default "__VITE_ASSET__DlPhCzPZ__"